import { TransactionTypeEnum } from '../enums/transaction-type.enum';

/**
 * Signs a customer payment for a ledger.
 *
 * Receipts and deposits are negative. Refunds are positive. Every other
 * type, including a missing type, stays positive. `amount` is used when it
 * is set; otherwise `totalGross` is used. A null amount with no gross is `0`.
 *
 * @param transaction A payment row with a type and an amount.
 * @returns The ledger-signed amount.
 */
export function toSignedTransactionAmount(transaction: {
  type?: TransactionTypeEnum | null;
  amount?: number | null;
  totalGross?: number | null;
}): number {
  const amount = Number(transaction.amount ?? transaction.totalGross ?? 0);

  switch (transaction.type) {
    case TransactionTypeEnum.DEPOSIT:
    case TransactionTypeEnum.RECEIPT:
      return -Math.abs(amount);
    case TransactionTypeEnum.REFUND:
    default:
      return Math.abs(amount);
  }
}
